export const OPEN_ACCOUNT_LINK = {
  TWSTOCK: 'https://supr.link/8OHaU',
  USSTOCK: 'https://supr.link/oYjcV',
  PORTFOLIOS: 'https://supr.link/7ARpa',
};
